import { configureStore } from '@reduxjs/toolkit'

import packageReducer from './packageSlice.js'
import userReducer from './userSlice.js'

const store = configureStore({
  reducer: {
    packages: packageReducer,
    user: userReducer,
  },
})

export default store
